import { useEffect, useLayoutEffect } from 'react';

interface DocumentTitleProps {
  title: string;
}

const useIsomorphicLayoutEffect = typeof document === 'undefined' ? useEffect : useLayoutEffect;

export function DocumentTitle({ title }: DocumentTitleProps) {
  const documentTitle = `${title} | Customer.io`;

  useIsomorphicLayoutEffect(() => {
    const previousTitle = document.title;
    document.title = documentTitle;

    return () => {
      if (document.title === documentTitle) {
        document.title = previousTitle;
      }
    };
  }, [documentTitle]);

  return null;
}
